
import get_tokens from 'https://ebs.sugoidogo.com/tba.mjs'
const client_id = '72wtxvzs6erokrj33lk105whmoo381'
const scope = 'chat:read chat:edit moderator:manage:shoutouts'
const tokens = await get_tokens(client_id, scope)

const resetLocalStorageButton = document.querySelector("button#resetLocalStorage")
resetLocalStorageButton.onclick = function () {
    if (window.confirm('This will erase all of your login tokens and reload the page. Continue?')) {
        window.localStorage.clear()
        window.location.reload()
    }
}

import localforage from 'localforage'
/** @type Storage */
const localStorage = localforage.createInstance({ name: 'clippy.v2' })
const resetLocalForageButton = document.querySelector("button#resetLocalForage")
resetLocalForageButton.onclick = function () {
    if (window.confirm("This will erase all of your clippy settings and reload the page. Continue?")) {
        localStorage.clear()
        window.location.reload()
    }
}

const templates = document.querySelector('#templates')

import FileReaderAsync from 'js-util/dist/FileReaderAsync'
const asset_file_input = document.querySelector('#asset_file_input')
const asset_list = document.querySelector('#asset_list')
async function addAsset(blob, filename = null) {
    if (filename === null) {
        filename = blob.name.split('.')[0]
    }
    const asset = templates.querySelector('.asset_list_item').cloneNode(true)
    console.debug(asset.outerHTML)
    const asset_name = asset.querySelector('.asset_name')
    const asset_type = asset.querySelector('.asset_type')
    const asset_data = asset.querySelector('.asset_data')
    asset_name.value = filename
    asset_type.innerHTML = blob.type
    asset_data.value = await FileReaderAsync.readAs('DataURL', blob)
    asset_list.append(asset)
}
asset_file_input.onchange = async function () {
    for (const file of asset_file_input.files) {
        addAsset(file)
    }
    asset_file_input.value = ''
}

const command_text_input = document.querySelector('#command_text_input')
const command_list = document.querySelector('#command_list')
const command_add_button = document.querySelector('#command_add_button')
function addCommand(command) {
    const command_list_item = templates.querySelector('.command_list_item').cloneNode(true)
    command_list_item.querySelector('input').value = command
    command_list.append(command_list_item)
}
command_add_button.onclick = function () {
    addCommand(command_text_input.value)
    command_text_input.value = ''
}
command_text_input.onkeydown = async function (event) {
    if (event.key == 'Enter') {
        command_add_button.onclick()
    }
}

const consent_text_input = document.querySelector('#consent_text_input')
const consent_list = document.querySelector('#consent_list')
const consent_add_button = document.querySelector('#consent_add_button')
function addConsentCommand(command) {
    const consent_list_item = templates.querySelector('.consent_list_item').cloneNode(true)
    consent_list_item.querySelector('input').value = command
    consent_list.append(consent_list_item)
}
consent_add_button.onclick = function () {
    addConsentCommand(consent_text_input.value)
    consent_text_input.value = ''
}
consent_text_input.onkeydown = async function (event) {
    if (event.key == 'Enter') {
        consent_add_button.onclick()
    }
}

const filter_select = document.querySelector('#filter_select')
const filter_list = document.querySelector('#filter_list')
const filter_add_button = document.querySelector('#filter_add_button')
filter_add_button.onclick = function () {
    const filter_list_item = templates.querySelector('.filter_' + filter_select.value).cloneNode(true)
    filter_list.append(filter_list_item)
    return filter_list_item
}

import sortable from 'sortablejs'
sortable.create(filter_list)


import { getFormDataDeep } from 'js-util/dist/FormDataDeep'
const config_select = document.querySelector('#config_select')
const form = document.querySelector('#config_span')
const status = document.querySelector('#status')
const link = document.querySelector('#browser_source_link')
form.onsubmit = async function (event) {
    event.preventDefault()
    status.hidden = false
    status.innerHTML = 'Saving settings...'
    const config = getFormDataDeep(event.target, true)
    console.debug(config)
    const name = config_select.value
    fetch('https://ts.sugoidogo.com/config/' + name + '.json', {
        headers: tokens.auth_headers,
        method: 'POST',
        body: JSON.stringify(config)
    }).then(async function (response) {
        if (!response.ok) {
            throw await response.text()
        }
        status.innerHTML = 'Settings saved'
        setTimeout(() => status.hidden = true, 1500)
    }).catch(error => {
        console.error(error)
        status.innerHTML = 'Error saving: ' + error
    })
}

const new_config_span = document.querySelector('#new_config_span')
config_select.onchange = async function () {
    const config_span = document.querySelector('#config_span')
    config_span.hidden = true
    if (config_select.value === '') {
        new_config_span.hidden = false
        status.hidden = true
        return
    } else {
        status.innerHTML = 'Loading...'
        status.hidden = false
        new_config_span.hidden = true
    }
    for (const list of [asset_list, command_list, filter_list, consent_list]) {
        while (list.hasChildNodes()) {
            list.childNodes[0].remove()
        }
    }
    for (const checkbox of config_span.querySelectorAll('input[type=checkbox]')) {
        checkbox.checked = false
    }
    for (const textarea of config_span.querySelectorAll('textarea')) {
        textarea.value = ''
    }
    const config = await fetch('https://ts.sugoidogo.com/config/' + config_select.value + '.json', {
        headers: tokens.auth_headers
    }).then(async response => {
        if (!response.ok) {
            throw await response.text()
        }
        return response.json()
    }).catch(error => {
        console.error(error)
        status.innerHTML = 'Error loading settings :' + error
        return null
    })
    if (!config.consentText) {
        config.consentText = await fetch('default.json').then(response => response.json()).then(json => json.consentText)
    }
    if (!config.allow_broadcaster) {
        config.allow_broadcaster = true
        config.allow_moderator = true
    }
    console.debug(config)
    for (let [key, value] of Object.entries(config)) {
        if (key.includes('command') && (typeof value === 'string' || value instanceof String)) {
            value = [value]
        }
        console.debug(key, typeof value, value)
        try {
            switch (typeof value) {
                case 'boolean': {
                    config_span.querySelector('[name=' + key + ']').checked = value
                    continue
                }
                case 'number':
                case 'string': {
                    config_span.querySelector('[name=' + key + ']').value = value
                    continue
                }
                case 'object': {
                    if (!(value instanceof Array)) {
                        value = [value]
                    }
                    switch (key) {
                        case 'commands': {
                            for (const command of value) {
                                addCommand(command)
                            }
                            continue
                        }
                        case 'consent_commands': {
                            for (const command of value) {
                                addConsentCommand(command)
                            }
                            continue
                        }
                        case 'filters': {
                            for (const filter of value) {
                                filter_select.value = filter.type
                                const filter_list_item = filter_add_button.onclick()
                                for (const [key, value] of Object.entries(filter)) {
                                    if (key === 'type') {
                                        continue
                                    }
                                    const dataElement = filter_list_item.querySelector('[name=' + key + ']')
                                    switch (dataElement.type) {
                                        case 'checkbox': case 'radio': {
                                            dataElement.checked = value
                                            break
                                        }
                                        default: {
                                            dataElement.value = value
                                            break
                                        }
                                    }
                                }
                            }
                            break
                        }
                        case 'assets': {
                            for (const asset of value) {
                                const data = await (await fetch(asset.data, { cache: 'no-cache' })).blob()
                                addAsset(data, asset.filename)
                            }
                        }
                    }
                }
            }
        } catch (e) {
            console.warn(e)
        }
    }
    const length = location.href.lastIndexOf('/')
    const url = new URL(location.href.substring(0, length + 1) + 'overlay.html')
    url.searchParams.append('name', config_select.value)
    url.searchParams.append('refresh_token', tokens.refresh_token)
    link.href = url
    config_span.hidden = false
    status.hidden = true
}
async function reload(value = undefined) {
    while (config_select.children.length != 0) {
        config_select.children[0].remove()
    }
    /** @type Array<String> */
    const config_names = await fetch('https://ts.sugoidogo.com/config/', {
        headers: tokens.auth_headers
    }).then(async response => {
        if (!response.ok) {
            throw await response.text()
        }
        return response.json()
    }).catch(error => {
        console.warn(error)
        return []
    })
    if (config_names.length == 0) {
        /** @type Array<String> */
        const local_config_names = await localStorage.keys()
        if (local_config_names.length > 0) {
            status.innerHTML = 'Uploading your settings to Sugoi Web Services...'
            for (const config_name of local_config_names) {
                const config = await localStorage.getItem(config_name)
                let hasFeatured = false
                for (const filter of config.filters) {
                    if (filter.type == 'featured') {
                        hasFeatured = true
                    }
                }
                if (!hasFeatured) {
                    config.filters.unshift({ 'type': 'featured' })
                }
                await fetch('https://ts.sugoidogo.com/config/' + config_name + '.json', {
                    headers: tokens.auth_headers,
                    method: 'POST',
                    body: JSON.stringify(config)
                }).then(async response => {
                    if (!response.ok) {
                        throw await response.text()
                    }
                }).catch(error => {
                    console.error(error)
                    status.innerHTML = 'There was a problem uploading your settings: ' + error
                })
                status.innerHTML = 'Upload complete!'
                location.reload()
            }
        }
    }
    for (let config_name of config_names) {
        config_name = config_name.replace('.json', '')
        const option = document.createElement('option')
        option.innerHTML = config_name
        option.value = config_name
        config_select.append(option)
    }
    const option = document.createElement('option')
    option.innerHTML = 'Create New'
    option.value = ''
    config_select.append(option)
    config_select.hidden = false
    if (value) {
        config_select.value = value
    }
    config_select.onchange()
}
function new_config() {
    new_config_span.hidden = true
    status.hidden = false
    fetch('default.json', { cache: 'no-cache' })
        .then((response) => response.json())
        .then((json) => fetch('https://ts.sugoidogo.com/config/' + new_config_text_input.value + '.json', {
            headers: tokens.auth_headers,
            method: 'POST',
            body: JSON.stringify(json)
        }))
        .then(() => {
            reload(new_config_text_input.value)
            new_config_text_input.value = ''
        })
}
const new_config_button = document.querySelector('#new_config_button')
const new_config_text_input = document.querySelector('#new_config_text_input')
new_config_span.onsubmit = function (event) {
    event.preventDefault()
    new_config()
}

const delete_config_button = document.querySelector('#delete_config_button')
delete_config_button.onclick = async function () {
    await fetch('https://ts.sugoidogo.com/config/' + config_select.value + '.json', {
        headers: tokens.auth_headers,
        method: 'DELETE'
    }).then(async response => {
        if (!response.ok) {
            status.innerHTML = 'failed to delete config: ' + await response.text()
        }
    })
    reload()
}
reload()